import md5 from"md5";export const getUserAvatar=email=>{return`https://www.gravatar.com/avatar/${md5(email)}?d=identicon`};